export default __webpack_public_path__ + "static/media/compressor-active.59a6ced5.svg";